import React, { Fragment, useState } from 'react';
import SlideMenu from './components/SlideMenu';
import MainContainer from './components/MainContainer';
import useScreen from '../hooks/useScreen';
import { Backdrop, Box, Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { routesName } from '../constants/routes-name';
import Header from '../landing-pages/components/Header';
import SideMenuNew from './components/SideMenuNew';
import TopHeaderMenu from './components/TopHeaderMenu';

const DashboardLayout = () => {
  const { user } = useSelector(({ user }) => user);
  if (user) {
    return <OldComponent />;
  }
  return <Navigate to={routesName.login} />;
};

export default DashboardLayout;

function OldComponent() {
  const { isMenuOverly } = useScreen();
  const [isMenuOpen, setIsMenuOpen] = useState(!isMenuOverly);
  const location = useLocation();
  const { pathname, search } = location;

  return (
    <Fragment>
      {/*   <TopHeaderMenu /> */}
      {/* <Header
        page={
          pathname === routesName.dashboard
            ? 'dashboard'
            : pathname === routesName.draftBids
            ? 'draftBids'
            : pathname === routesName.submittedBids
            ? 'submittedBids'
            : pathname === routesName.chats
            ? 'chats'
            : pathname === routesName.openChat
            ? 'openChat'
            : pathname === routesName.supplierAllTenderListing
            ? 'allTender'
            : pathname === routesName.myTenders
            ? 'myTender'
            : pathname === routesName.unApprovedTenders
            ? 'unApprovedTenders'
            : `${pathname}`.includes(routesName.viewTenderPath)
            ? 'viewTender'
            : `${pathname}`.includes(routesName.bidTenderPath)
            ? 'bidTender'
            : `${pathname}`.includes(routesName.editUnApprovedTendersPath)
            ? 'editUnApprovedTendersPath'
            : ''
        }
      /> */}
      <div className="my-24 px-2">
        <div className="flex justify-center">
          <Box
            sx={{
              width: { xl: '75%', lg: '85%', md: '95%', xs: '100%' },
            }}
          >
            <Grid container spacing={2}>
              <Grid item lg={isMenuOpen ? 2 : 0} className="raletive">
                <div
                  style={{
                    position: isMenuOverly ? 'absolute' : 'sticky',
                    top: isMenuOverly ? '35%' : '100px',
                  }}
                >
                  <SideMenuNew
                    isMenuOpen={!isMenuOverly ? true : isMenuOpen}
                    setIsMenuOpen={setIsMenuOpen}
                  />
                </div>
              </Grid>
              <Grid item lg={isMenuOpen ? 9 : 12}>
                <div className="md:px-6 px-4">
                  <Outlet />
                  <Backdrop
                    sx={{
                      color: '#fff',
                      zIndex: (theme) => theme.zIndex.drawer + 1,
                    }}
                    open={isMenuOverly && isMenuOpen}
                    onClick={() => setIsMenuOpen(false)}
                  />
                </div>
              </Grid>
            </Grid>
          </Box>
        </div>
      </div>
    </Fragment>
  );

  return (
    <div className="flex flex-column bg-gray-200">
      <div style={{ position: isMenuOverly ? 'absolute' : 'inherit' }}>
        <SlideMenu isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      </div>
      <div className="flex-1 overflow-y-auto h-screen">
        <MainContainer />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isMenuOverly && isMenuOpen}
          onClick={() => setIsMenuOpen(false)}
        />
      </div>
    </div>
  );
}

/* import React, { useState } from 'react';
import SlideMenu from './components/SlideMenu';
import MainContainer from './components/MainContainer';
import useScreen from '../hooks/useScreen';
import { Backdrop } from '@mui/material';

function Component() {
  const { isMenuOverly } = useScreen();
  const [isMenuOpen, setIsMenuOpen] = useState(!isMenuOverly);

  return (
    <div className="flex flex-column bg-gray-200">
      <div style={{ position: isMenuOverly ? 'absolute' : 'inherit' }}>
        <SlideMenu isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      </div>
      <div className="flex-1 overflow-y-auto h-screen">
        <MainContainer />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isMenuOverly && isMenuOpen}
          onClick={() => setIsMenuOpen(false)}
        />
      </div>
    </div>
  );
}

export default Component;
 */
